<template>
  <SchoolSwitcher
    :items="schools"
    label="Search for a school"
    prependInnerIcon=""
    :searchInputHandler="searchSchool"
    :setSelect="setSchool"
  />
</template>

<script>
  import {mapActions, mapGetters, mapState} from 'vuex';
  import SchoolSwitcher from './SchoolSwitcher';

  export default {
    name: "SchoolAutocomplete",
    components: {
        SchoolSwitcher
    },
    data() {
      return {
        lastSelect: null,
      };
    },
    mounted() {
      this.searchSchool('');
    },
    methods: {
      ...mapActions(['searchSchool', 'setSchool', 'clearAllFilters']),
    },
    computed: {
      ...mapState({
        site_code: s => s.school.selected ? s.school.selected.site_code : ''
      }),
      ...mapGetters(['schools']),
    },
    watch: {
      site_code: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.clearAllFilters();
        }
      }
    },
  }
</script>

<style scoped>

</style>
